import React from 'react';
export default function ShortenedTitle({title}){
    if(!title)
        return null;
    const [titles, extra] = title.split('+');
    return <p className="saved-filter-text-title"><span className="saved-filter-text-wrap">{titles}</span>{extra ? `+${extra}` :''}</p>; 
}
